import React, { useEffect } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import CalendarModal from "../CalendarSale/CalendarModal/CalendarModal";
import { MdArrowBackIosNew } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CALENDAR_SALE } from "../../routes";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import qs from "qs";
import { setExerciseName, setExerciseZoneId } from "../../store/pseudoModal/pseudoModalsActions";

const ModalWindow: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const exerciseNames = useSelector((state: State) => state.pseudoModals.exerciseName);
  const exercisesZoneId = useSelector((state: State) => state.pseudoModals.exerciseZoneId);

  const exerciseIdsParam = qs.parse(location.search.slice(1)).exerciseIds as string;
  const exerciseNameParam = qs.parse(location.search.slice(1)).exerciseName as string;

  useEffect(() => {
    if (exerciseNameParam && exerciseIdsParam) {
      dispatch(setExerciseName(exerciseNameParam));
      dispatch(setExerciseZoneId(Number(exerciseIdsParam)));
    }
    //eslint-disable-next-line
  }, [exerciseIdsParam, exerciseNameParam]);

  return (
    <React.Fragment>
      <div className="modal-window-header flex-start-center">
        <button onClick={() => navigate(CALENDAR_SALE)} className="back-button flex-start-center">
          <MdArrowBackIosNew className="back-button-icon" />
          <b>{t("wroc")}</b>
        </button>
        <h1>
          {t("kup_bilet")}:<b>{exerciseNames}</b>
        </h1>
      </div>
      <div>
        {exerciseNames.length > 2 && exercisesZoneId && (
          <CalendarModal exerciseName={exerciseNames} zone={exercisesZoneId} />
        )}
      </div>
    </React.Fragment>
  );
};

export default ModalWindow;
